<template>
  <section class="w-full relative" :id="article.handle">
    <!-- desktop 1440x900 -->
    <UiArticleMediaImage 
      v-if="mediaImage" 
      class="hidden md:block" 
      :src="mediaImage.image.url" 
      :altText="altText"
      :title="article.title" 
      :overlaytop="index === 0" 
      :fetchpriority="index === 0 ? 'high' : 'auto'"
      :overlaybottom="true"  
      :width="Number(1440)" 
      :height="Number(900)"
      :sizes="'md:1024px lg:1280px xl:1535 2xl:2500'"
      :modifiers="{
        auto: 'format,compress',
        fit: 'crop',
        ar: '1440:900',    
        'fp-x': mediaImage.presentation?.asJson.focalPoint.x ?? 0.5,
        'fp-y': mediaImage.presentation?.asJson.focalPoint.y ?? 0.5
      }" 
    />

    <!-- mobile 375x464 -->
    
    <UiArticleMediaImage 
      v-if="mediaImage" 
      class="block md:hidden" 
      :src="mediaImage.image.url" 
      :altText="altText"
      :title="article.title" 
      :overlaytop="index === 0" 
      :fetchpriority="index === 0 ? 'high' : 'auto'"
      :overlaybottom="true" 
      :width="Number(412)" 
      :height="Number(510)"
      :sizes="'412px sm:640px'"
      :modifiers="{
        auto: 'format,compress',
        fit: 'crop',
        ar: '375:464',
        'fp-x': mediaImage.presentation?.asJson.focalPoint.x ?? 0.5,
        'fp-y': mediaImage.presentation?.asJson.focalPoint.y ?? 0.5
      }"  
    />

    <div class="absolute w-full h-full top-0 pt-0 pb-4 md:py-0">
      <UiContentwrapper class="h-full relative">
        <UiFullcolumn :class="index === 0 ? 'justify-end' : 'justify-end'">
          
          <!-- HEADER FOR FIRST SLIDE -->
          <div v-if="index === 0" class="row1 md:flex-grow flex items-center justify-start">
            <div ref="blurHeadingRef" id="blurheading" :style="getblurstyle" class="text-white hidden md:block pt-52">
              <h1 class="large">{{ article.title }}</h1>              
            </div>            
            <h1 class="text-white large md:hidden">{{ article.title }}</h1>              
          </div>

          <!-- Article content -->
          <div class="gravaagrid mx-auto text-white pb-2 md:pb-16 md:text-center">            
            <div class="col-span-10 md:col-span-6 md:col-start-3 pb-4 md:pb-0">
              <h1 v-if="index > 0" class="mb-1 md:mb-5" v-html="article.title" />
              <AnimationFadeUp>
                <p class="large mx-auto text-white mb-0">{{ article.content }}</p>
              </AnimationFadeUp>            
            </div>
          </div>

          <!-- CTA with link extracted from <a> in post -->
          <template v-if="article.excerpt">
            <div v-if="index === 0" class="flex justify-end md:absolute bottom-16 right-0">
              <NuxtLink :to="extractLink(article.excerpthtml)">
                <UiRippleButton class="brown" v-motion-slide-right :delay="1200">
                  {{ article.excerpt }}
                </UiRippleButton>                
              </NuxtLink>
            </div>
            <div v-else class="flex justify-end md:absolute bottom-[50%] right-0">
              <AnimationSlideRight :is="'button'">
                <NuxtLink :to="extractLink(article.excerpthtml)">                                
                  <UiRippleButton class="white">
                    {{ article.excerpt }}
                  </UiRippleButton>    
                </NuxtLink>
              </AnimationSlideRight>
            </div>
          </template>

        </UiFullcolumn>
      </UiContentwrapper>
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue';

const UiArticleMediaImage = defineAsyncComponent(() => import('@/components/ui/ArticleMediaImage.vue'));
const UiRippleButton = defineAsyncComponent(() => import('@/components/ui/RippleButton.vue'));
const AnimationSlideRight = defineAsyncComponent(() => import('@/components/animation/slideRight.vue'));

const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})

const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  scrollprogress: {
    type: Number,
    required: false
  }
});


const altText = computed(() => {
  return mediaImage.value?.image.altText || props.article.title || 'Gravaa image';
  
});

const blurHeadingRef = ref(null);

const mediaImage = computed(() => props.article.coverImage?.reference || null);


// Method to extract link from excerpt
const extractLink = (excerpt) => {
  const linkMatch = excerpt.match(/href="([^"]*)"/);
  return linkMatch ? linkMatch[1] : '#';
};

const getblurstyle = computed(() => { 
  const progress = props.scrollprogress;  
  if (progress > 1000) return;

  const blurValue = progress > 120 ? (progress - 120) * 0.05 : 0;
  const translateXValue = progress * 0.8;

  return {
    filter: `blur(${blurValue}px)`,
    transform: `translateX(${translateXValue}px)`
  };
});
</script>

<style scoped>
@reference "../../assets/css/main.css";
h2{
  @apply text-2xl md:text-5xl mb-2 md:mb-4 ;
    font-variation-settings: 'wght' 410, 'wdth' 100, 'slnt' 0; 
}

</style>
